module.exports = __webpack_public_path__ + "img/default-ice-cream.d9ea36bd.svg";